import React, { Component } from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import RadioField from "./RadioField";
import TextField from "./TextField";
import SelectField from "./SelectField";
import DateField from "./DateField";
import CheckBoxField from "./CheckBoxField"

import "./Form.css";
import renderIf from "../../utils/renderIf";

class FormField extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    if (
      this.props.value === nextProps.value &&
      this.props.editable === nextProps.editable &&
      this.props.required === nextProps.required &&
      this.props.showError === nextProps.showError
    ) {
      return false;
    }
    return true;
  }

  render() {
    const {
      name,
      label,
      type,
      value,
      onChanged,
      dataSource,
      editable,
      required,
      showError,
      regEx,
      transform,
      maxLength,
      multiline,
      yardProps,
      helpText,
      questionLabel,
      positionHelpText,
      mutitle,
    } = this.props;

    return (
      <div className="form-field">
        {renderIf(type === "display")(
          <Grid container spacing={24} className="custom-grid">
            <Grid item xs={6} sm={6}>
              <strong>{label}</strong>
            </Grid>
            <Grid item xs={6} sm={6} className="text-right">
              {transform(value)}
            </Grid>
          </Grid>
        )}
        {renderIf(type === "text")(
          <div>
            <TextField
              placeholder={label}
              label={questionLabel}
              positionHelpText={positionHelpText}
              value={value !== null ? transform(value) : ""}
              key={name}
              type={type}
              editable={editable}
              required={required}
              onChanged={(value, error) => onChanged(name, value, error)}
              showError={showError}
              maxLength={maxLength}
              multiline={multiline}
              regEx={regEx}
              helpText={helpText}
            />
          </div>
        )}
        {renderIf(type === "file")(
          <div>
            <TextField
              placeholder={label}
              label={label}
              positionHelpText={positionHelpText}
              value={value !== null ? transform(value) : ""}
              key={name}
              type={type}
              editable={editable}
              required={required}
              onChanged={(value, error) => onChanged(name, value, error)}
              showError={showError}
              maxLength={maxLength}
              multiline={multiline}
              regEx={regEx}
              helpText={helpText}
              mutitle={mutitle}
            />
          </div>
        )}
        {renderIf(type === "date")(
          <div>
            <DateField
              placeholder={label}
              key={name}
              onChanged={(value, error) => onChanged(name, value, error)}
              type={type}
              value={value}
              editable={editable}
              required={required}
              showError={showError}
              yardProps={yardProps}
              label={label}
            />
          </div>
        )}
        {renderIf(type === "autoSelect")(
          <SelectField
            value={value !== null ? value : ""}
            key={name}
            dataSource={dataSource}
            editable={editable}
            required={required}
            onChanged={(value, error) => onChanged(name, value, error)}
            showError={showError}
          />
        )}
        {renderIf(type === "radio")(
          <RadioField
            label={label}
            name={name}
            value={value}
            dataSource={dataSource}
            editable={editable}
            required={required}
            onChanged={(value, error) => onChanged(name, value, error)}
            showError={showError}
          />
        )}
        {renderIf(type === "checkbox")(
          <CheckBoxField
            label={label}
            name={name}
            value={value}
            dataSource={dataSource}
            editable={editable}
            required={required}
            onChanged={(value, error) => onChanged(name, value, error)}
            showError={showError}
          />
        )}
      </div>
    );
  }
}

FormField.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  editable: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.string,
  onChanged: PropTypes.func,
  onSuggestSelect: PropTypes.bool,
  onSuggestAddressBlur: PropTypes.bool
};

export default FormField;



// WEBPACK FOOTER //
// ./src/components/form/FormField.js